import { ReactNode } from 'react';

import { useConfirm } from '@/components/ui/confirm-dialog';

export type RegenerateConfirmOptions = {
  header: string;
  description: string;
  warningTitle: string;
  warningDetail: ReactNode;
  acceptLabel?: string;
  rejectLabel?: string;
  onAccept: () => void;
  onReject?: () => void;
};

export const useRegenerateConfirm = () => {
  const confirm = useConfirm();

  return ({
    header,
    description,
    warningTitle,
    warningDetail,
    acceptLabel = 'Regenerate',
    rejectLabel = 'Cancel',
    onAccept,
    onReject,
  }: RegenerateConfirmOptions) => {
    confirm({
      title: header,
      confirmVariant: 'warning',
      confirmLabel: acceptLabel,
      cancelLabel: rejectLabel,
      onConfirm: onAccept,
      onCancel: onReject,
      body: (
        <div className="flex flex-col gap-4 pt-2">
          <p className="text-gray-700">{description}</p>
          <div className="rounded-lg border border-amber-300 bg-amber-50 p-3">
            <div className="flex items-center gap-2 font-semibold text-amber-800">
              <i className="pi pi-exclamation-triangle text-amber-600" />
              <span>{warningTitle}</span>
            </div>
            <div className="mt-1 text-sm text-amber-700">{warningDetail}</div>
          </div>
        </div>
      ),
    });
  };
};
